/* ChillMate Luxe — theme behaviors */
(function () {
  'use strict';

  /* mobile nav */
  var burger = document.querySelector('.cm-burger');
  var mobileNav = document.querySelector('.cm-mobile-nav');
  if (burger && mobileNav) {
    burger.addEventListener('click', function () {
      mobileNav.classList.toggle('is-open');
      burger.setAttribute('aria-expanded', mobileNav.classList.contains('is-open') ? 'true' : 'false');
    });
  }

  /* reveal on scroll */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    document.querySelectorAll('.cm-reveal').forEach(function (el) { io.observe(el); });
  } else {
    document.querySelectorAll('.cm-reveal').forEach(function (el) { el.classList.add('is-visible'); });
  }

  /* gallery thumbs — set src AND srcset so responsive candidates don't override */
  var mainImg = document.querySelector('.cm-gallery__main img');
  document.querySelectorAll('.cm-gallery__thumb').forEach(function (t) {
    t.addEventListener('click', function () {
      document.querySelectorAll('.cm-gallery__thumb').forEach(function (x) { x.classList.remove('is-active'); });
      t.classList.add('is-active');
      if (mainImg) {
        var src = t.getAttribute('data-src');
        if (src) {
          mainImg.srcset = '';
          mainImg.src = src;
          mainImg.removeAttribute('srcset');
        }
        var alt = t.getAttribute('data-alt');
        if (alt) mainImg.alt = alt;
      }
    });
  });

  /* qty steppers */
  document.querySelectorAll('[data-qty]').forEach(function (wrap) {
    var input = wrap.querySelector('input');
    wrap.querySelectorAll('button').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var min = parseInt(input.getAttribute('min') || '0', 10) || 0;
        var v = parseInt(input.value || '1', 10) + (btn.getAttribute('data-step') === 'down' ? -1 : 1);
        input.value = Math.max(min, v);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });

  /* cart page: auto-submit quantities on change */
  var cartItemsForm = document.querySelector('.cm-cart__items');
  if (cartItemsForm) {
    cartItemsForm.querySelectorAll('input[name="updates[]"]').forEach(function (input) {
      input.addEventListener('change', function () {
        cartItemsForm.submit();
      });
    });
  }

  /* ---- PDP variant selection (generic: works with any option names) ---- */
  var pdpForm = document.getElementById('cm-product-form');
  if (pdpForm) {
    var dataEl = document.getElementById('cm-variants-json');
    var variants = dataEl ? JSON.parse(dataEl.textContent) : [];
    var state = {}; /* optionName -> value */
    var priceEl = document.querySelector('[data-pdp-price]');
    var compareEl = document.querySelector('[data-pdp-compare]');
    var idInput = document.getElementById('cm-variant-id');
    var submitBtn = pdpForm.querySelector('button[type="submit"]');
    var selectedLabels = document.querySelectorAll('[data-opt-selected]');

    function optionValues(v) {
      return [v.option1, v.option2, v.option3].filter(function (x) { return x !== undefined && x !== null; });
    }

    function findVariant() {
      var keys = Object.keys(state);
      return variants.filter(function (v) {
        var vals = optionValues(v);
        return keys.every(function (k) { return vals.indexOf(state[k]) !== -1; });
      })[0];
    }

    function setLabels() {
      selectedLabels.forEach(function (l) { l.textContent = state[l.getAttribute('data-opt-name')] || ''; });
    }

    function selectOption(group, value) {
      state[group] = value;
      pdpForm.querySelectorAll('[data-option="' + group + '"]').forEach(function (b) {
        b.classList.toggle('is-active', b.getAttribute('data-value') === value);
      });
    }

    function update() {
      var v = findVariant();
      if (v) {
        idInput.value = v.id;
        if (priceEl) priceEl.textContent = v.priceFormatted;
        if (compareEl) compareEl.textContent = v.compareFormatted || '';
        var available = v.available !== false;
        if (submitBtn) {
          submitBtn.disabled = !available;
          submitBtn.textContent = available ? submitBtn.getAttribute('data-label') : 'Sold out';
        }
        if (mainImg && v.image && v.image.src) {
          mainImg.srcset = '';
          mainImg.removeAttribute('srcset');
          mainImg.src = v.image.src;
          mainImg.alt = v.image.alt || mainImg.alt;
        }
        /* keep URL shareable */
        try {
          var url = new URL(window.location);
          url.searchParams.set('variant', String(v.id));
          history.replaceState({}, '', url);
        } catch (e) { /* noop */ }
      }
      setLabels();
    }

    pdpForm.querySelectorAll('[data-option]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        selectOption(btn.getAttribute('data-option'), btn.getAttribute('data-value'));
        update();
      });
    });

    /* initialize: from ?variant= if present, else first available */
    var initial = null;
    try {
      var qp = new URLSearchParams(window.location.search).get('variant');
      if (qp) {
        var decoded = parseInt(qp, 10);
        if (!isNaN(decoded)) initial = variants.filter(function (v) { return v.id === decoded; })[0];
      }
    } catch (e) { /* noop */ }
    if (!initial) initial = variants.filter(function (v) { return v.available !== false; })[0] || variants[0];

    if (initial) {
      var initialVals = optionValues(initial);
      pdpForm.querySelectorAll('[data-option]').forEach(function (b) {
        if (initialVals.indexOf(b.getAttribute('data-value')) !== -1) b.click();
      });
      update();
    }
  }

  /* ---- AJAX add to cart ---- */
  document.querySelectorAll('form[action^="/cart/add"]').forEach(function (form) {
    form.addEventListener('submit', function (ev) {
      var btn = form.querySelector('button[type="submit"]');
      if (!btn || btn.name === 'checkout') return;
      ev.preventDefault();
      var original = btn.textContent;
      var variantInput = form.querySelector('[name="id"]');
      var qtyInput = form.querySelector('[name="quantity"]');
      btn.disabled = true;
      btn.textContent = 'Adding…';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          id: variantInput ? variantInput.value : null,
          quantity: qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1
        })
      })
        .then(function (r) {
          return r.json().then(function (data) { return { ok: r.ok, data: data }; });
        })
        .then(function (res) {
          if (res.ok) {
            window.location.href = '/cart';
          } else {
            var msg = (res.data && res.data.description) || (res.data && res.data.message) || 'Could not add to cart';
            btn.disabled = false;
            btn.textContent = original;
            var errEl = form.querySelector('.cm-add-error');
            if (!errEl) {
              errEl = document.createElement('p');
              errEl.className = 'cm-add-error cm-form-errors';
              btn.insertAdjacentElement('afterend', errEl);
            }
            errEl.textContent = msg;
          }
        })
        .catch(function () {
          btn.disabled = false;
          btn.textContent = original;
          form.submit();
        });
    });
  });
})();
